module.exports = __webpack_public_path__ + "static/espresso-8dd1f1e3489391fce2961c0ce4cd2a58.png";